import {addUrlParams} from '@rambler-id/url'
import {captureException} from 'utils/sentry'
import {request} from './transport'

interface RecommendationsRecord {
  feed_id: string
  feed_title: string
  item_description: string
  item_duration: string
  item_id: string
  item_image: string
  item_title: string
  item_url: string
  rambler_video_clickUrl: string
  rambler_video_id: string
  rcm_id: string
  show_id: string
  _id: string
}

export const getRecommendations = async (
  url: string,
  params: Record<string, any>
): Promise<RecommendationsRecord[]> => {
  try {
    const response = await request(addUrlParams(url, params), {timeout: 10000})
    const {recommendations = []} = await response.json()

    return recommendations
  } catch (error: any) {
    captureException(error, {url})
    throw error
  }
}
